<mat-toolbar>
  <div
    fxLayout="row"
    fxLayoutAlign="center center"
    fxLayoutAlign.gt-xs="space-between center"
    fxFlex
  >
    <a
      href="/"
      target="_blank"
      mat-button
      class="pink"
      fxFlex="0 0 auto"
      fxLayout="row"
      fxLayoutAlign="start center"
    >
      <span>© {{options.environment?.application.display}}</span>
    </a>

  </div>
</mat-toolbar>
